// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#aboutTabs[data-v-e98d3824] ul{justify-content:center}@media (min-width:64rem){#aboutTabs[data-v-e98d3824] .tab-controls__tab{padding:1rem}}#aboutTabs[data-v-e98d3824] .tab-controls__indicator{border-radius:99px;margin-top:-4px;padding:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
